import React from "react";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import { Tooltip } from "@mui/material";

const HotelAPK = (props) => {

    const renderVideoPreview = (row) => {
        return <Tooltip title="Download APK" className="cursor-pointer" arrow>
            <div className="py-2">
                <a href={row?.apkUrl} className="un-published"
                >
                    Download Apk
                </a>
            </div>
        </Tooltip>
    }

    const columns = [
        { field: "apkName", headerName: "APK Name", flex: 1 },
        { field: "activityName", headerName: "Activity Name", flex: 1 },
        { field: "packageName", headerName: "Package Name", flex: 1 },
        { field: "version", headerName: "Version", flex: 1 },
        {
            field: 'videoUrl', headerName: 'Download Apk', flex: 1, row: true, renderCell: renderVideoPreview, disableSortIcon: true,
        },
    ];
   
    return (
        <div className="hotel-list">
           <div className="cdsn-detail-homepage-preview mb-3">
                <p><b>Room Details</b></p>
                <p className="mb-0">Room No: {props?.hotelAPKList?.roomNo !==""?props?.hotelAPKList?.roomNo:"N.A"}</p>
            </div>
            <p><b>APK Details</b></p>
            <TableWrapper
                data={[props?.hotelAPKList]}
                columns={columns}
                noPagination={true}
            />
        </div>
    )
}

export default HotelAPK;